














import GetUsersDevicesQuery from '@/graphql/queries/getUsersDevices.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';
import DeviceInfoDisplay from '@/components/DeviceInfoDisplay.vue';
import AddDevice from '@/components/AddDevice.vue';
import IDevice from '@/interfaces/device';

@Component({
  components: {
    DeviceInfoDisplay,
    AddDevice,
  },
})
export default class ManageDevices extends Vue {
  public devices: IDevice[] = [];
  public newDeviceId: string | undefined;

  public mounted() {
    this.getDevices();
  }

  public getDevices(newDeviceId?: string) {
    this.newDeviceId = newDeviceId;

    request(GetUsersDevicesQuery as any, {})
      .then(({ data }) => {
        this.devices = data.getUsersDevices;
      })
      .catch(error => {
        // TODO: Error handling
      });
  }

  public getWarningMessage(deviceId: string): string {
    return deviceId === this.newDeviceId
      ? 'Please remember to set the tag & token on this device or data will not be sent to the server.'
      : '';
  }
}
